import axios from "axios";
import "./axiosInterceptor";
export const PASARELA = process.env.VUE_APP_URLPASARELA;
export const Reportes = {
  // Datos de reporte con fecha desde hasta
  getReporteDesdeHasta(params) {
    return axios.get(PASARELA + "/reporte/cliente", { params });
  },
};

const reporteMovimiento = async (params) => {
  const data = await axios.get(PASARELA + "/reporte/movimientos-comisiones", {
    params,
  });

  return data;
};

const reporteMovimientoTemporal = async (params) => {
  const data = await axios.get(
    PASARELA + "/reporte/movimientos-comisiones-temporales",
    {
      params,
    }
  );

  return data;
};

const reporteCobranza = async (params) => {
  const { data } = await axios.get(PASARELA + "/reporte/cobrazas-cliente", {
    params,
  });

  return data;
};

const reporteRendiciones = async (params) => {
  const { data } = await axios.get(PASARELA + "/reporte/rendiciones-cliente", {
    params,
  });

  return data;
};

const reporteRendicionesTotales = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/rendiciones-cliente-totales",
    {
      params,
    }
  );
  return data;
};

const reporteRendicionesDetalles = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/rendiciones-cliente-detalle-adaptado",
    {
      params,
    }
  );
  return data;
};

const reporteRendicionesDetallesSubtotales = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/rendiciones-cliente-detalle-adaptado-subtotales",
    {
      params,
    }
  );
  return data;
};



const reporteRendicionesSplit = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/rendiciones-cliente-split",
    {
      params,
    }
  );

  return data;
};

//Reportes para Cuentas Split
const reporteRendicionesSubcuentas = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/rendiciones-cliente-subcuentas",
    {
      params,
    }
  );

  return data;
};

// const reporteReversiones = async (params) => {
//   const { data } = await axios.get(PASARELA + "/reporte/reversiones-cliente", {
//     params,
//   });

//   return data;
// };

const reporteReversiones = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/reversiones-cliente-cuenta",
    {
      params,
    }
  );

  return data;
};

const reporteReversionesSplit = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/reporte/reversiones-cliente-cuenta-split",
    {
      params,
    }
  );

  return data;
};

const reporteClientes = async (params) => {
  const { data } = await axios.get(PASARELA + "/reporte/cliente", {
    params,
  });

  return data;
};

export default {
  reporteMovimiento,
  reporteCobranza,
  reporteRendiciones,
  reporteRendicionesSplit,
  reporteRendicionesSubcuentas,
  reporteReversiones,
  reporteReversionesSplit,
  reporteMovimientoTemporal,
  reporteClientes,
  reporteRendicionesTotales,
  reporteRendicionesDetalles,
  reporteRendicionesDetallesSubtotales,
  reporteReversionesSplit,
};
